/**
 * Branch carrier internal task definitions.
 * Internal tasks are staff-only, created at bind, and require UW Ops review.
 * See: https://github.com/gobranch/branch/issues/27732
 */
import type { InternalTaskDefinition } from '../../../config/types';

import { homeQualityVerification } from './home-quality-verification';
import { uwUmbrellaReview } from './uw-umbrella-review';
import { confirmNotAForeclosure } from './confirm-not-a-foreclosure';
import { distanceToFireHydrant } from './distance-to-fire-hydrant';
import { garageMailingAddressMismatch } from './garage-mailing-address-mismatch';
import { homeLowMarketValue } from './home-low-market-value';
import { carWithBusinessUse } from './car-with-business-use';
import { potentialCommercialVehicle } from './potential-commercial-vehicle';
import { trailerWithRestrictedUse } from './trailer-with-restricted-use';
import { illogicalCombinationReview } from './illogical-combination-review';
import { homeRequiresManualReview } from './home-requires-manual-review';
import { primaryResidenceVerification } from './primary-residence-verification';
import { oddNumberOfMarriedDrivers } from './odd-number-of-married-drivers';

export const allBranchInternalTaskDefinitions: InternalTaskDefinition[] = [
  homeQualityVerification,
  uwUmbrellaReview,
  confirmNotAForeclosure,
  distanceToFireHydrant,
  garageMailingAddressMismatch,
  homeLowMarketValue,
  carWithBusinessUse,
  potentialCommercialVehicle,
  trailerWithRestrictedUse,
  illogicalCombinationReview,
  homeRequiresManualReview,
  primaryResidenceVerification,
  oddNumberOfMarriedDrivers
];

export type { InternalTaskInput, InternalTaskOutput } from './types';
